
import React, { useState, useEffect } from 'react';
import ConnectionStatusComponent from './ConnectionStatus';
import ConnectionModeToggle from './ConnectionModeToggle';
import { useSharePoint } from '@/context/SharePointContext';

const ConnectionSettings = () => {
  const { siteUrl } = useSharePoint();
  
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium">SharePoint Connection Settings</h3>
        <p className="text-sm text-muted-foreground">
          Configure and manage connections to Microsoft 365 SharePoint services.
        </p>
      </div>
      
      {/* Connection Status Card */}
      <ConnectionStatusComponent siteUrl={siteUrl || ''} />
      
      {/* SharePoint Connection Configuration */}
      <ConnectionModeToggle />
    </div>
  );
};

export default ConnectionSettings;
